import { api } from 'api/api';
import { ProposalResponseViewModel } from 'types/proposal';
import { GetProposalsRequest, UpdateProposalRequest, ProposalsResponse, CreateProposalRequest } from './types';
import { parametrizeURL } from 'api/utils';

export const PROPOSAL_URL = 'Proposal' as const;
export const GET_PROPOSALS_URL = `${PROPOSAL_URL}/GetAllAsync` as const;
export const ADD_PROPOSAL_URL = `${PROPOSAL_URL}/AddAsync` as const;
export const ESTIMATE_PROPOSAL_URL = `${PROPOSAL_URL}/EstimateAsync` as const;
export const SET_CLIENT_CONFIRM_PROPOSAL_URL = `${PROPOSAL_URL}/SetClientConfirmAsync/{proposalId}` as const;
export const UPDATE_PROPOSAL_URL = `${PROPOSAL_URL}/UpdateAsync/{proposalId}` as const;

export const readProposalById = (params: { id: string }) =>
    api.get<ProposalResponseViewModel>(PROPOSAL_URL, { params });

export const deleteProposalById = (data: { id: string }) => api.delete<void>(PROPOSAL_URL, { data });

export const readProposals = (params?: GetProposalsRequest) =>
    api.get<ProposalsResponse>(GET_PROPOSALS_URL, { params });

export const createProposal = (body: CreateProposalRequest) =>
    api.post<ProposalResponseViewModel>(ADD_PROPOSAL_URL, body);

export const estimateProposal = (body: CreateProposalRequest) =>
    api.post<ProposalResponseViewModel>(ESTIMATE_PROPOSAL_URL, body);

export const replaceProposal = (proposalId: string, body: UpdateProposalRequest) =>
    api.post<ProposalResponseViewModel>(parametrizeURL(UPDATE_PROPOSAL_URL, { proposalId }), body);

export const setClientConfirmedProposal = (proposalId: string, body: { isClientConfirmed: boolean }) =>
    api.post<ProposalResponseViewModel>(parametrizeURL(SET_CLIENT_CONFIRM_PROPOSAL_URL, { proposalId }), body);
